import { useOidcAccessToken } from '@axa-fr/react-oidc';

export const useAuthToken = () => {
  const { accessToken, accessTokenPayload } = useOidcAccessToken();

  return {
    accessToken,
    accessTokenPayload,
    isAuthenticated: !!accessToken,
    getAuthHeader: () => (accessToken ? `Bearer ${accessToken}` : null),
  };
};
